import { Link } from "react-router-dom";
import { useRouteMeta } from "@/lib/seo";

export function AccessDeniedPage() {
  useRouteMeta({
    title: "Access denied — Soweto Super United FC",
    description: "You do not have permission to view this page.",
    noindex: true,
  });
  return (
    <section className="mx-auto max-w-2xl px-4 py-16 text-center">
      <h1 className="font-display text-4xl text-primary">Access denied</h1>
      <p className="mt-2 text-muted-foreground">
        Your account does not have permission to view this page. If you think this is a mistake,
        contact your club administrator.
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
      >
        Return home
      </Link>
    </section>
  );
}
